import ConfigService from "../../service/config/config.service";

export default class UrlService {
  async getApiUrl(): Promise<string> {
    return (await ConfigService.get()).apiUrl;
  }
}
